import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@root/environments/environment';
import { AnalysisCode } from '@core/core.types';

@Injectable({
  providedIn: 'root',
})
export class AnalysisCodesService {
  private http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/productCatalogue/analysis-codes`;

  getAnalysisCodes() {
    return this.http.get<
      { laboratory: string; analysisCodes: AnalysisCode[] }[]
    >(this.apiUrl);
  }
}
